import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enTranslation from './locales/en/translation.json';
import thTranslation from './locales/th/translation.json';
import viTranslation from './locales/vi/translation.json';
import idTranslation from './locales/id/translation.json';
import tlTranslation from './locales/tl/translation.json';
import msTranslation from './locales/ms/translation.json';

const resources = {
  en: {
    translation: enTranslation,
  },
  th: {
    translation: thTranslation,
  },
  vi: {
    translation: viTranslation,
  },
  id: {
    translation: idTranslation,
  },
  tl: {
    translation: tlTranslation,
  },
  ms: {
    translation: msTranslation,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,

    interpolation: {
      escapeValue: false, // React already escapes by default
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
  });

export default i18n;
